/**
 * Ajax Product Switches
 * Handles loading product pages dynamically when a linked product swatch is clicked.
 */

class AjaxProductSwitches {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    // Event delegation for dynamically loaded content
    document.addEventListener('click', (e) => {
      const link = e.target.closest('.js-ajax-product-link');
      if (link) {
        e.preventDefault();
        this.handleProductSwitch(link);
      }
    });

    // Handle browser back/forward buttons
    window.addEventListener('popstate', (e) => {
      if (e.state && e.state.productUrl && e.state.sectionId) {
        this.fetchProduct(e.state.productUrl, e.state.sectionId, false);
      } else {
        // If no state, reload the page to be safe
        window.location.reload();
      }
    });
  }

  handleProductSwitch(link) {
    const productUrl = link.getAttribute('data-url');
    if (!productUrl) return;

    // Find the closest shopify-section wrapper
    const sectionWrapper = link.closest('.shopify-section');
    if (!sectionWrapper || !sectionWrapper.id) return;

    const sectionId = sectionWrapper.id.replace('shopify-section-', '');

    this.fetchProduct(productUrl, sectionId, true, sectionWrapper);
  }

  fetchProduct(url, sectionId, pushState = true, sectionWrapper = null) {
    if (!sectionWrapper) {
      sectionWrapper = document.getElementById(`shopify-section-${sectionId}`);
    }

    if (!sectionWrapper) return;
    
    // 1. Add loading state to the main product area
    sectionWrapper.style.opacity = '0.5';
    sectionWrapper.style.transition = 'opacity 0.2s ease';
    sectionWrapper.style.pointerEvents = 'none';

    // 2. Fetch the new product's section HTML via Shopify Section Rendering API
    const fetchUrl = `${url}${url.includes('?') ? '&' : '?'}section_id=${sectionId}`;

    fetch(fetchUrl)
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then((responseText) => {
        // 3. Parse the returned HTML
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const fetchedSection = html.getElementById(`shopify-section-${sectionId}`);
        
        if (fetchedSection) {
            // 4. Replace the innerHTML
            // Replacing innerHTML of the section wrapper forces custom elements (like <section-product>) 
            // inside it to re-initialize automatically in most modern Shopify themes.
            sectionWrapper.innerHTML = fetchedSection.innerHTML;
            
            // 5. Update browser URL history
            if (pushState) {
                window.history.pushState({ productUrl: url, sectionId: sectionId }, '', url);
                
                // Update the document title if we can find it
                const newTitle = html.querySelector('title');
                if (newTitle) {
                    document.title = newTitle.innerText;
                }
            }
            
            // Dispatch a custom event so other scripts can re-init if needed
            document.dispatchEvent(new CustomEvent('ajaxProductSwitch:loaded', {
                detail: { sectionId: sectionId, sectionElement: sectionWrapper }
            }));
        } else {
            throw new Error('Section not found in response');
        }
      })
      .catch((e) => {
        console.error('Error fetching ajax product switch:', e);
        // Fallback to standard navigation if something fails
        window.location.href = url;
      })
      .finally(() => {
        // Remove loading state
        sectionWrapper.style.opacity = '1';
        sectionWrapper.style.pointerEvents = 'auto';
      });
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  new AjaxProductSwitches();
});
